import { useState } from "react";

export function useFormValues<T>(initialValues: T) {
  const [formValues, setFormValues] = useState<T>(initialValues);

  const handleInputChange = (name: keyof T, value: any) => {
    // Update form values
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const resetFormValues = () => {
    setFormValues(initialValues);
  };

  const resetFormValue = (name: keyof T) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: initialValues[name],
    }));
  };

  return [
    formValues,
    handleInputChange,
    resetFormValues,
    resetFormValue,
    setFormValues,
  ] as const;
}

interface UseStepsResult {
  step: number;
  nextStep: (e: React.MouseEvent<HTMLButtonElement>) => void;
  prevStep: (e: React.MouseEvent<HTMLButtonElement>) => void;
  goToStep: (stepNumber: number) => void;
  isLastStep: boolean;
  isFirstStep: boolean;
}

export const useSteps = (
  initialStep: number = 1,
  totalSteps: number,
): UseStepsResult => {
  const [step, setStep] = useState(initialStep);

  const nextStep = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (step < totalSteps) {
      setStep((prev) => prev + 1);
    }
  };

  const prevStep = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (step > 1) {
      setStep((prev) => prev - 1);
    }
  };

  const goToStep = (stepNumber: number) => {
    if (stepNumber >= 1 && stepNumber <= totalSteps) {
      setStep(stepNumber);
    }
  };

  return {
    step,
    nextStep,
    prevStep,
    goToStep,
    isLastStep: step === totalSteps,
    isFirstStep: step === 1,
  };
};
